import he from './he';

export default { he } as any;
